import { render } from "./upload.svg?vue&type=template&id=43e8b0d4"
const script = {}

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__